import { StyleSheet } from 'aphrodite';
import { IAutomationTemplate } from '../../../../../extViewmodels';
import {
	Combobox,
	ComboboxContent,
	ComboboxEmpty,
	ComboboxInput,
	ComboboxItem,
	ComboboxItemRadioIndicator,
	ComboboxList,
} from '../../../../components-v2/Combobox';

interface Props {
	automationChoices?: IAutomationTemplate[];
	selectedAutomation: IAutomationTemplate | null;
	onSetTemplate?(template: IAutomationTemplate): void;
}

const itemToStringLabel = (automation: IAutomationTemplate | 'None') => {
	if (automation !== 'None') {
		return `${automation.name} (Created by ${automation.creator?.firstName} ${automation.creator?.lastName})`;
	}
	return automation;
};

export const MeetingReminders = ({ automationChoices, selectedAutomation, onSetTemplate }: Props) => {
	const items = ['None', ...automationChoices];
	return (
		<Combobox
			items={items}
			value={selectedAutomation ?? 'None'}
			onValueChange={value => onSetTemplate(value === 'None' ? null : (value as IAutomationTemplate))}
			itemToStringLabel={value => itemToStringLabel(value as IAutomationTemplate)}
			isItemEqualToValue={(item, value) => {
				if (value === 'None' && item === 'None') {
					return true;
				}
				return (item as IAutomationTemplate)?.id === (value as IAutomationTemplate)?.id;
			}}
		>
			<ComboboxInput placeholder='Select a meeting reminder' styles={[s.input]} />
			<ComboboxContent>
				<ComboboxEmpty>No meeting reminders found</ComboboxEmpty>
				<ComboboxList>
					{(automation: IAutomationTemplate) => (
						<ComboboxItem key={automation?.id ?? 'meeting-reminders-empty'} value={automation}>
							<ComboboxItemRadioIndicator />
							{itemToStringLabel(automation)}
						</ComboboxItem>
					)}
				</ComboboxList>
			</ComboboxContent>
		</Combobox>
	);
};

const s = StyleSheet.create({
	input: {
		maxWidth: 568,
	},
});
